module.exports = __webpack_public_path__ + "media/images/badges/purebarre/PureBarre-6500-Classes-Inactive-bbcb27ae38745e97a9aaa8872494212e.png";